import React, { createContext, useContext, useState } from 'react';
import { clearOnlineSessionFields } from '../lib/clear-online-session';

export interface GameConfig {
  size: 7 | 9;
  ranked: boolean;
  local: boolean;
  mode: 'ai' | 'online' | 'friend' | 'local';
  matchId?: string;
  opponent?: string;
  opponentId?: string;
  ended?: boolean;
  matchSessionId?: string;
}

export interface GameResult {
  win: boolean;
  ranked: boolean;
  local: boolean;
  mode: string;
  size: number;
  matchId?: string;
  stats?: {
    moves: number;
    timeSec: number;
    wallsP1: number;
    wallsP2: number;
    startWalls: number;
    surrender?: boolean;
  };
  ratingDelta?: number | null;
  opponent?: string;
  opponentId?: string;
}

interface GameContextValue {
  gameCfg: GameConfig;
  setGameCfg: React.Dispatch<React.SetStateAction<GameConfig>>;
  result: GameResult;
  setResult: React.Dispatch<React.SetStateAction<GameResult>>;
}

const GameContext = createContext<GameContextValue | null>(null);

export function GameProvider({ children }: { children: React.ReactNode }) {
  const [gameCfg, setGameCfg] = useState<GameConfig>({ size: 9, ranked: true, local: false, mode: 'ai' });
  const [result, setResult] = useState<GameResult>({ win: true, ranked: false, local: false, mode: 'ai', size: 9 });

  return (
    <GameContext.Provider value={{ gameCfg, setGameCfg, result, setResult }}>
      {children}
    </GameContext.Provider>
  );
}

export function useGame() {
  const ctx = useContext(GameContext);
  if (!ctx) throw new Error('useGame outside provider');
  return ctx;
}

/** Reset stale match identity between online sessions. */
export function clearOnlineSession(
  setGameCfg: React.Dispatch<React.SetStateAction<GameConfig>>,
) {
  setGameCfg((prev) => clearOnlineSessionFields(prev));
}
